export default __webpack_public_path__ + "static/media/home-right-vector.c6cbd1b0.png";